import { View, ViewProperties, ViewProperty } from '@/App';
import { IconButton, Stack } from '@/components';
import { auth } from '@/firebase/FirebaseProvider';
import { closeApplication } from '@/utils/editor';
import logo from 'assets/logo.svg';
import classNames from 'classnames';
import { signOut } from 'firebase/auth';
import React from 'react';
import { LuLogOut, LuX } from 'react-icons/lu';
import styles from './Sidebar.module.css';

interface NaviationItemProps {
  view: View;
  isActive: boolean;
  onClick?: () => void;
}

const NavigationItem = ({ view, isActive, onClick }: NaviationItemProps) => {
  const viewProperty: ViewProperty = ViewProperties[view];
  return (
    <div
      className={classNames(styles.navigationItem, {
        [styles.active]: isActive,
      })}
      onClick={onClick}
    >
      {React.cloneElement(viewProperty.icon, {
        className: classNames(styles.navigationItemIcon, {
          [styles.active]: isActive,
        }),
        size: 24,
      })}
    </div>
  );
};

interface SidebarProps {
  currentView?: View;
  viewChange: (view: View) => void;
}

const Sidebar = ({ currentView, viewChange }: SidebarProps): JSX.Element => {
  return (
    <div className={styles.sidebar}>
      <div className={styles.sidebarContainer}>
        <div className={styles.header}>
          <img
            className={styles.logo}
            src={logo}
            alt="Flatten application logo"
          />
          <Stack spacing={2}>
            <NavigationItem
              view={View.PROJECT}
              isActive={currentView === View.PROJECT}
              onClick={() => viewChange(View.PROJECT)}
            ></NavigationItem>
            <NavigationItem
              view={View.PROFILE}
              isActive={currentView === View.PROFILE}
              onClick={() => viewChange(View.PROFILE)}
            ></NavigationItem>
            <NavigationItem
              view={View.DEVELOPMENT}
              isActive={currentView === View.DEVELOPMENT}
              onClick={() => viewChange(View.DEVELOPMENT)}
            ></NavigationItem>
          </Stack>
        </div>
        <Stack spacing={2}>
          <IconButton
            onClick={() => {
              signOut(auth);
            }}
            icon={<LuLogOut></LuLogOut>}
          />
          <IconButton icon={<LuX />} onClick={closeApplication} />
        </Stack>
      </div>
    </div>
  );
};

export default Sidebar;
